import Api from './Api';
import Csrf from './Csrf';

const LoginQrCode = {
    async generateQrCode() { // anonymous
        await Csrf.getCookie();
        return Api.get('/qr-code/generate');
    },
    async checkLoginWithQrCode(uniqueId) {
        await Csrf.getCookie();
        return Api.get(`/qr-code/check/${uniqueId}`);
    }
};

export default LoginQrCode;